import { GetLodgingRequestsState, GetLodgingRequestsActionTypes, GET_LODGING_REQUESTS_DATA_REQUEST, GET_LODGING_REQUESTS_DATA_SUCCESS, GET_LODGING_REQUESTS_DATA_FAILURE } from "store/reducers/lodgingRequest/get/types";

const defaultState: GetLodgingRequestsState = {
  isLoading: false,
  errorMessage: ""
};

export default function getLodgingRequests(state = defaultState, action: GetLodgingRequestsActionTypes): GetLodgingRequestsState {
  switch (action.type) {
    case GET_LODGING_REQUESTS_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_LODGING_REQUESTS_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_LODGING_REQUESTS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};